/* istanbul ignore file */
import { takeLatest } from 'redux-saga/effects'
import { TRACK_ANALYTICS4_EVENT } from '../actions/types'
import { trackTealiumEvent } from 'commons/js/services/analytics'

export function * launchG4AnalyticsEvent ({event}) {
    trackTealiumEvent(event)
}

export function * watchAnalyticsEvents () {
    yield takeLatest(TRACK_ANALYTICS4_EVENT, launchG4AnalyticsEvent)
}

export default watchAnalyticsEvents
